import type { EditableField } from "./types";

export const FIELD_LABEL: Record<string, string> = {
  owner_user_id: "Owner",
  file_name: "File name",
  amount: "Amount",
  forecast: "Forecast",
  stage_key: "Stage",
  outcome: "Outcome",
  coe_date: "COE",
  lock_status: "Lock",
  lock_expires_on: "Lock expiry",
  last_cd_date: "Last CD",
  signing_date: "Signing",
  funded_date: "Funded date",
  target_month: "Target month",
  price: "Price",
  note_rate: "Note rate",
  broker: "Broker",
  loan_type: "Loan type",
  loan_number: "Loan #",
  appraisal: "Appraisal",
  hoi_ok: "HOI",
  title_ok: "Title",
  form_4506_ok: "4506-C",
  notes: "Notes",
  deleted_at: "Deleted",
  team_id: "Team",
};

export function fieldLabel(f: EditableField | string): string {
  return FIELD_LABEL[f] ?? f;
}
